import { render, staticRenderFns } from "./Startups.vue?vue&type=template&id=66a33fd0&scoped=true"
import script from "./Startups.vue?vue&type=script&lang=js"
export * from "./Startups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a33fd0",
  null
  
)

export default component.exports